import { AuthGuard, PermissionGuard } from '@abp/ng.core';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EquipmentComponent } from './components/equipment.component';
import { EquipmentDetailsComponent } from './components/equipment-details/equipment-details.component';

const routes: Routes = [
  {
    path: '',
    component: EquipmentComponent,
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: ':id',
    component: EquipmentDetailsComponent,
    canActivate: [AuthGuard, PermissionGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EquipmentRoutingModule {}
